import { IDiagnosis } from '../caremap/ICareMap';
import { CareMapState } from '../caremap/CareMapState';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { StructuredRecordFormState } from './structured-records/StructuredRecordFormState';
import { DiagnosisDescriptor } from './DiagnosisDescriptor';

export class DiagnosisFormState extends StructuredRecordFormState<IDiagnosis> {
    static inject = () => [CareMapState, MixPanelEventEmitter, DiagnosisDescriptor];

    constructor(
        careMapState: CareMapState,
        mixpanel: MixPanelEventEmitter,
        protected descriptor: DiagnosisDescriptor
    ) {
        super(careMapState, mixpanel);
    }
}
